import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TagList from '../../Tags/TagList';
import Field from '../../Field/Field2';
import './ContentTags.scss';

class ContentTags extends PureComponent {
  /**
   * When a tag is added
   */
  onAddTag = (tag) => {
    const {
      onChange,
    } = this.props;

    onChange({
      _id: tag._id,
      name: tag.name,
      type: tag.type,
      action: 'add',
    });
  };

  /**
   * When a tag is removed
   */
  onRemoveTag = (tag) => {
    const {
      onChange,
    } = this.props;

    onChange({
      _id: tag._id,
      action: 'remove',
    });
  };

  render() {
    const {
      className,
      textStyle,
      isEdit,
      editable,
      tags,
      companyId,
      user,
      tabIndex,
      hideIcon,
    } = this.props;

    return (
      <div className={classNames('ContentTags', className)}>
        <div
          className="tags"
          style={textStyle}
        >
          <TagList
            tags={tags}
            hideIcon={hideIcon}
          />
        </div>

        {editable && isEdit ? (
          <div className="edit-container">
            <Field
              type="tags"
              label="Tags"
              tagProps={{
                assign: user.can('location.assign_tag'),
                companyId,
                tags,
                showTagsInline: true,
                showTagsList: false,
                onAdd: this.onAddTag,
                onRemove: this.onRemoveTag,
              }}
              tabIndex={tabIndex}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

ContentTags.propTypes = {
  className: PropTypes.string,
  /** Content is editable */
  editable: PropTypes.bool,
  /** Content is in edit mode */
  isEdit: PropTypes.bool,
  /** Location Tags */
  tags: PropTypes.arrayOf(PropTypes.object),
  /** Company ID */
  companyId: PropTypes.string,
  /** Text Style */
  textStyle: PropTypes.oneOfType([
    PropTypes.object,
  ]),
  /** Tab Index */
  tabIndex: PropTypes.number,
  /** Hide the tag list icon */
  hideIcon: PropTypes.bool,
  /** When tags change after being edited */
  onChange: PropTypes.func,
};

ContentTags.defaultProps = {
  className: '',
  companyId: '',
  editable: false,
  isEdit: false,
  tags: [],
  tabIndex: 0,
  textStyle: {},
  hideIcon: false,
  onChange: () => {},
};

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(ContentTags);
